module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crm-wrapper"
  }, [_c('div', {
    staticClass: "enquiries"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.bullet.bulletinTitle))]), _vm._v(" "), _c('div', {
    staticClass: "text-left text-in",
    domProps: {
      "innerHTML": _vm._s(_vm.bullet.bulletinContent)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.bullet.bulletinPublisher))]), _vm._v(" "), _c('p', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.bullet.createTimeString))])]), _vm._v(" "), (_vm.bullet.files) ? _c('div', {
    staticClass: "enquiries mt-10"
  }, [_c('div', {
    staticClass: "enquiries-title"
  }, [_c('span'), _vm._v(_vm._s(_vm.$t('frame.relatedFiles')) + "\r\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "enquiries-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 user-lst"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "lt"
  }, [_vm._v(_vm._s(_vm.$t('frame.relatedFiles')) + ":")]), _vm._v(" "), _c('li', {
    staticClass: "rt"
  }, [_c('a', {
    attrs: {
      "href": _vm.bullet.files,
      "target": "_self"
    }
  }, [_c('t-icon', {
    attrs: {
      "type": "aid-menu aid-file-document"
    }
  }), _vm._v(_vm._s(_vm.$t('frame.doc')))], 1)])])])])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-608e5b23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/notice.vue
// module id = 89
// module chunks = 0